import * as Sentry from '@sentry/react';
import i18next from 'i18next';
import { LOCALE_COOKIE_EXPIRY, LOCALE_COOKIE_NAME } from './locales';
export async function setLocale(lang, io) {
    if (lang === i18next.language) {
        return;
    }
    if (io.isNative) {
        // WHY: native persists to Preferences (capacitor:// drops the cookie); the reload re-inits i18next from it.
        // WHY: best-effort — a failed persist is logged but must not block the reload (ANCR-2647).
        try {
            await io.persistLocale(lang);
        } catch (error) {
            Sentry.captureException(error);
        }
    } else {
        io.cookies.setCookie(LOCALE_COOKIE_NAME, lang, {
            expires: LOCALE_COOKIE_EXPIRY
        });
    }
    io.locationReload();
}
